function productHop(container) {
  const productSectionsAll = document.querySelectorAll(container);

  for (const productSection of productSectionsAll) {
    const products = productSection.querySelectorAll('.product_item');
    const productArray = Array.from(products);
    const total = productArray.length;

    let lastRandom = -1;
    let hopInterval;

    hopInterval = setInterval(() => {
      productArray.forEach(p => p.classList.remove('active_hop'));

      let random;
      do {
        random = Math.floor(Math.random() * total);
      } while (random === lastRandom && total > 1);

      productArray[random].classList.add('active_hop');
      lastRandom = random;

    }, 3000);
  }
}

